import { apiClient } from '@/lib/api-client';

/**
 * QA SS4-005 — a manager approves an action for a lower role with their POS
 * PIN (the T16 flow the POS uses). The action names the token on both sides.
 */
export type ManagerApprovalAction = 'QUOTE_CANCEL' | 'CORPORATE_OVER_LIMIT';

export interface Approver {
  id: string;
  name: string;
  role: 'OWNER' | 'MANAGER';
}

export interface ManagerApprovalGrant {
  approval_id: string;
  /** Single use, about 5 minutes, only for the signed-in user. */
  approval_token: string;
  expires_at: string;
  approver: Approver;
}

export const managerApprovalService = {
  listApprovers(locationId?: string) {
    const qs = locationId ? `?location_id=${encodeURIComponent(locationId)}` : '';
    return apiClient<Approver[]>(`/manager-approval/approvers${qs}`);
  },

  verify(dto: {
    approver_id: string;
    pin: string;
    action: ManagerApprovalAction;
    subject_id?: string;
    location_id?: string;
  }) {
    return apiClient<ManagerApprovalGrant>('/manager-approval/verify', {
      method: 'POST',
      body: dto,
    });
  },
};
